import React from "react";

const skills = [
  { name: "Java", level: "Intermediate" },
  { name: "Spring Boot", level: "Intermediate" },
  { name: "SQL", level: "Intermediate" },
  { name: "JPA", level: "Intermediate" },
  { name: "RESTful API", level: "Intermediate" },
];

const Backend = () => {
  const halfLength = Math.ceil(skills.length / 2);
  const skillsLeft = skills.slice(0, halfLength);
  const skillsRight = skills.slice(halfLength);

  return (
    <div className="skills__content">
      <h3 className="skills__title">Backend developer</h3>
      <div className="skills__box">
        <div className="skills__column">
          {skillsLeft.map((skill, index) => (
            <div className="skills__group" key={index}>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
                <div>
                  <h3 className="skills__name">{skill.name}</h3>
                  <span className="skills__level">{skill.level}</span>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="skills__column">
          {skillsRight.map((skill, index) => (
            <div className="skills__group" key={index + halfLength}>
              <div className="skills__data">
                <i className="bx bx-badge-check"></i>
                <div>
                  <h3 className="skills__name">{skill.name}</h3>
                  <span className="skills__level">{skill.level}</span>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Backend;
